import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';

import { AppBridgeProvider } from './providers/AppBridgeProvider';
import { AuthProvider } from './providers/AuthProvider';
import { StoreProvider } from './providers/StoreProvider';
import { AdminAuthProvider } from './providers/AdminAuthProvider';

import Dashboard from './pages/Dashboard';
import BarEditor from './pages/BarEditor';
import Settings from './pages/Settings';
import Analytics from './pages/Analytics';
import Billing from './pages/Billing';
import Experiments from './pages/Experiments';
import ExperimentEditor from './pages/ExperimentEditor';
import NotFound from './pages/NotFound';
import Feedback from './pages/Feedback';

import {
  AdminLogin,
  AdminDashboard,
  AdminStores,
  AdminStoreDetail,
  AdminDiscounts,
  AdminAnalytics,
  AdminSupport,
} from './pages/admin';

function App() {
  return (
    <BrowserRouter>
      <AppProvider i18n={enTranslations}>
        <Routes>
          {/* Public routes - no auth, no AppBridge */}
          <Route path="/feedback" element={<Feedback />} />

          {/* Admin Routes - Outside of AppBridge for app owner access */}
          <Route
            path="/admin/*"
            element={
              <AdminAuthProvider>
                <Routes>
                  <Route path="/" element={<AdminLogin />} />
                  <Route path="/dashboard" element={<AdminDashboard />} />
                  <Route path="/stores" element={<AdminStores />} />
                  <Route path="/stores/:id" element={<AdminStoreDetail />} />
                  <Route path="/discounts" element={<AdminDiscounts />} />
                  <Route path="/analytics" element={<AdminAnalytics />} />
                  <Route path="/support" element={<AdminSupport />} />
                </Routes>
              </AdminAuthProvider>
            }
          />

          {/* Main App Routes - Embedded in Shopify */}
          <Route
            path="/*"
            element={
              <AppBridgeProvider>
                <AuthProvider>
                  <StoreProvider>
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/app" element={<Dashboard />} />
                      <Route path="/app/bars" element={<Dashboard />} />
                      <Route path="/app/bars/new" element={<BarEditor />} />
                      <Route path="/app/bars/:id" element={<BarEditor />} />
                      <Route path="/app/settings" element={<Settings />} />
                      <Route path="/app/analytics" element={<Analytics />} />
                      <Route path="/app/experiments" element={<Experiments />} />
                      <Route path="/app/experiments/new" element={<ExperimentEditor />} />
                      <Route path="/app/experiments/:id" element={<ExperimentEditor />} />
                      <Route path="/app/billing" element={<Billing />} />
                      <Route path="*" element={<NotFound />} />
                    </Routes>
                  </StoreProvider>
                </AuthProvider>
              </AppBridgeProvider>
            }
          />
        </Routes>
      </AppProvider>
    </BrowserRouter>
  );
}

export default App;
